// PURPOSE: Log an outreach reply by how it reads, using the shared action dialog.
// CONTRACT: Spec 091; offered only from server allowed_actions. Positive is preselected; the server enforces the parked
//   follow-up date and the negative reason list.
// DEPENDS: Catalog action dialog and native client version/idempotency envelope.
// CEILING: No Gmail access, sends or sentiment guessing.
import { ActionDialog } from './forms';
import type { NativeRecord } from './types';

export const SENTIMENT_LABELS: Record<string, string> = {
  positive: 'Positive · becomes a client', neutral: 'Neutral · not now', parked: 'Parked · come back later', negative: 'Negative · archive',
};
const REASONS = [{ value: 'hard_no', label: 'Declined' }, { value: 'wrong_contact', label: 'Wrong contact' },
  { value: 'not_fit', label: 'Not a fit' }, { value: 'role_filled', label: 'Role filled' }];

export function LogReplyDialog({ record, onClose, onSaved }: { record: NativeRecord; onClose(): void; onSaved(): void }) {
  const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  return <ActionDialog record={record} action={{ name: 'log_reply', label: 'Log reply',
    description: 'Every reply stops the emails. Neutral follows up in 5 business days unless you pick a date; parked needs a date; negative archives the lead.',
    fields: [
      { name: 'sentiment', label: 'How did it read?', type: 'select', required: true, default: 'positive',
        options: Object.entries(SENTIMENT_LABELS).map(([value, label]) => ({ value, label })) },
      { name: 'summary', label: 'What they said', type: 'textarea', required: true },
      { name: 'next_step', label: 'Next step', type: 'string' },
      { name: 'followup_on', label: 'Follow up on', type: 'date', description: 'Needed for parked. Not used for negative.' },
      { name: 'reason', label: 'Why not', type: 'select', options: REASONS, description: 'Only for negative. Defaults to Declined.' },
      { name: 'happened_on', label: 'Reply date', type: 'date', default: today },
    ] }} onClose={onClose} onSaved={onSaved} />;
}
